import { Component, input, OnInit, output } from "@angular/core";
import { DropDown } from "@components/drop-down/drop-down";
import { Indications } from "@components/indication/indications";
import { Answer } from "@domain/Answer";
import { DropDownExercise as DropDownExerciseEntity } from "@domain/Exercise";
import { AnswerFactory } from "@domain/factories/Answer.factory";

@Component({
  selector: "app-drop-down-exercise",
  imports: [DropDown, Indications],
  template: `
    <div data-testid="drop-down-exercise">
      <app-indications>Choisis le bon mot pour compléter la phrase.</app-indications>

      <div class="exercise">
        <p class="exercise__answer-sentence" data-testid="exercise-answer-sentence">
          @for (sentencePart of exercise().getSentenceToCompleteParts(); track sentencePart) {
            @if (sentencePart === "[dropdown]") {
              <span class="answer-sentence__dropdown">
                <app-drop-down
                  [disabled]="answer()?.isSubmitted()"
                  [class]="getDropDownClass()"
                  [selectedValue]="answer()?.value"
                  [values]="exercise().suggestedAnswers"
                  name="multiple-choices-drop-down"
                  (selectOption)="handleAnswerSelection($event)"
                  label="Choisir la bonne réponse parmi les choix suivants"
                />
              </span>
            } @else {
              <span class="sentence-part">{{ sentencePart }}</span>
            }
          }
        </p>
      </div>
    </div>
  `,
  styles: `
    @use "responsive" as *;
    @use "typography" as *;

    .exercise {
      padding: 20px 0;
      margin-top: 20px;

      @include screenWidth("from-desktop") {
        margin-top: 40px;
      }
    }

    .exercise__sentence {
      line-height: 150%;
      padding-bottom: 24px;
      margin-bottom: 24px;
      border-bottom: 2px dashed #f5f3ef;
      @include body2();

      @include screenWidth("from-desktop") {
        padding-bottom: 28px;
        margin-bottom: 28px;
        @include body1();
      }
    }

    .exercise__answer-sentence {
      display: block;
      gap: 8px;
      align-items: center;
      color: var(--text-primary, #152942);
      line-height: 46px;
      @include body2();

      @include screenWidth("from-desktop") {
        @include body1();
      }

      .sentence-part {
        ~ .answer-sentence__dropdown {
          margin-left: 8px;

          @include screenWidth("from-desktop") {
            margin-left: 12px;
          }
        }
      }

      .answer-sentence__dropdown {
        ~ .sentence-part {
          margin-left: 8px;

          @include screenWidth("from-desktop") {
            margin-left: 12px;
          }
        }
      }
    }
  `,
})
export class DropDownExercise implements OnInit {
  exercise = input.required<DropDownExerciseEntity>();
  answer = input.required<Answer | undefined>();

  selectAnswer = output<Answer | undefined>();

  sentenceParts?: string[];
  answers?: string[];

  ngOnInit() {
    const { sentence } = this.exercise();

    this.sentenceParts = sentence
      .replace("bonjour", "[defaultValue]")
      .split(/(\[defaultValue\])/)
      .filter(part => part !== "");
  }

  handleAnswerSelection(newValue?: string) {
    if (!newValue) {
      this.selectAnswer.emit(undefined);
      return;
    }

    this.selectAnswer.emit(AnswerFactory.createNewAnswer(newValue));
  }

  protected getDropDownClass() {
    const answer = this.answer();

    if (!answer) return "";

    if (answer.isCorrect()) {
      return "is-correct";
    }

    if (answer.isIncorrect()) {
      return "is-incorrect";
    }

    return "";
  }
}
